import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useTranslations } from 'next-intl';

const ZoomButton = ({ setSwiperIsZoomed, swiperIsZoomed = false, zoomBtnIsHidden }) => {
  // translations
  const t = useTranslations('ProductDetails');

  const zoomInSvg = (
    <svg viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" className="zoom-in-svg">
      <rect x=".5" y=".5" width="39" height="39" rx="19.5" fill="#fff" />
      <g clipPath="url(#a)">
        <path d="m24.82 23.66 3.513 3.512-1.16 1.161-3.514-3.514a7.351 7.351 0 0 1-4.608 1.616 7.387 7.387 0 0 1-7.384-7.384 7.387 7.387 0 0 1 7.384-7.384 7.387 7.387 0 0 1 7.384 7.384 7.351 7.351 0 0 1-1.616 4.608Zm-1.646-.61a5.725 5.725 0 0 0 1.62-4 5.742 5.742 0 0 0-5.743-5.742 5.741 5.741 0 0 0-5.743 5.743 5.742 5.742 0 0 0 5.743 5.743 5.725 5.725 0 0 0 4-1.62l.123-.123Zm-4.944-4.82v-2.46h1.641v2.461h2.462v1.641H19.87v2.462h-1.64V19.87h-2.462v-1.64h2.461Z" fill="#D23235" />
      </g>
      <rect x=".5" y=".5" width="39" height="39" rx="19.5" stroke="#D23235" />
      <defs>
        <clipPath id="a">
          <path fill="#fff" d="M10 10h20v20H10z" />
        </clipPath>
      </defs>
    </svg>
  );

  const zoomOutSvg = (
    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" className="zoom-out-svg">
      <rect x="0.5" y="0.5" width="39" height="39" rx="19.5" fill="white" />
      <path d="M24.8173 23.6577L28.3299 27.1694L27.1694 28.3299L23.6577 24.8173C22.351 25.8648 20.7257 26.4345 19.051 26.4322C14.9767 26.4322 11.6699 23.1254 11.6699 19.051C11.6699 14.9767 14.9767 11.6699 19.051 11.6699C23.1254 11.6699 26.4322 14.9767 26.4322 19.051C26.4345 20.7257 25.8648 22.351 24.8173 23.6577ZM23.1722 23.0491C24.213 21.9788 24.7943 20.544 24.7919 19.051C24.7919 15.8788 22.2225 13.3102 19.051 13.3102C15.8788 13.3102 13.3102 15.8788 13.3102 19.051C13.3102 22.2225 15.8788 24.7919 19.051 24.7919C20.544 24.7943 21.9788 24.213 23.0491 23.1722L23.1722 23.0491V23.0491ZM15.7705 18.2309H22.3315V19.8712H15.7705V18.2309Z" fill="#D23235" />
      <rect x="0.5" y="0.5" width="39" height="39" rx="19.5" stroke="#D23235" />
    </svg>
  );

  const ariaLabel = swiperIsZoomed ? t('carousel.ctas.zoom.shrink.label') : t('carousel.ctas.zoom.enlarge.label');

  return (
    <button
      aria-label={ariaLabel}
      className={classNames('carousel-zoom-btn', { 'scaled-down': zoomBtnIsHidden })}
      onClick={() => {
        if (swiperIsZoomed) {
          setSwiperIsZoomed(false);
        } else {
          setSwiperIsZoomed(true);
        }
      }}
      title={ariaLabel}
      type="button"
    >
      {swiperIsZoomed && (
        zoomOutSvg
      )}

      {!swiperIsZoomed && (
        zoomInSvg
      )}
    </button>
  );
};

ZoomButton.propTypes = {
  setSwiperIsZoomed: PropTypes.func.isRequired,
  swiperIsZoomed: PropTypes.bool,
  zoomBtnIsHidden: PropTypes.bool.isRequired,
};

export default ZoomButton;
